import { useEffect, useRef } from 'react';

import { useLocation, useNavigation } from '@remix-run/react';

import { useNectarAnalyticsContext } from './useNectarAnalyticsContext';

// Hook for automatically tracking page views
export const useNectarPageView = (): void => {
  const location = useLocation();
  const navigation = useNavigation();
  const lastPathRef = useRef<string>('');

  const analytics = useNectarAnalyticsContext();

  // Track page view when location changes
  useEffect(() => {
    // Don't track duplicate page views for the same path
    if (location.pathname === lastPathRef.current) return;

    // Don't track during navigation loading states
    if (navigation.state !== 'idle') return;

    analytics.trackPageView();

    // Update tracking state to prevent duplicate page view events for the same path
    lastPathRef.current = location.pathname;
  }, [location.pathname, navigation.state, analytics]);

  // Track initial page view on mount
  useEffect(() => {
    analytics.trackPageView();

    // Update tracking state to prevent duplicate page view events for the same path
    lastPathRef.current = location.pathname;
  }, [analytics, location.pathname]);
};
